<app-inner-box>
  <app-subpage-header title="Mitarbeiter"></app-subpage-header>
  <app-add-edit-modal (refresh)="listComponent.onRefreshList()"></app-add-edit-modal>
  <br>
  <app-list #listComponent></app-list>
</app-inner-box>
